import styled from "styled-components"

export const PopupViewInnerCategoryWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1300;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	.popupContainer {
		width: 60%;
		max-height: 90vh;
		background-color: #fff;
		border-radius: 16px;
		padding: 32px;
		display: flex;
		flex-direction: column;
		gap: 0;
		.popupHeader {
			flex-shrink: 0;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-bottom: 12px;
			button {
				font-size: 24px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				background-color: transparent;
				border: none;
				cursor: pointer;
				color: #27272a;
			}
		}
		.popupBody {
			flex: 1;
			overflow-y: auto;
			min-height: 0;
			display: flex;
			flex-direction: column;
			gap: 12px;
			> div {
				p {
					margin: 0;
				}
				&:nth-child(1) {
					p {
						color: #261b6a;
						font-family: Tajawal;
						font-size: 34px;
						font-weight: 700;
						line-height: 40.8px;
						text-align: right;
					}
				}
				&:nth-child(2) {
					margin-top: 50px;
					border-bottom: 1px solid #eaeafd;
					padding-bottom: 32px;
					p {
						&:first-child {
							font-size: 12px;
							font-weight: 400;
							line-height: 14.4px;
							color: #000000;
						}
						&:last-child {
							font-size: 18px;
							font-weight: 700;
							line-height: 21.6px;
							color: #261b6a;
							margin-top: 15px;
						}
					}
				}
				&:nth-child(3) {
					padding-top: 24px;
					gap: 16px;
					p {
						font-size: 12px;
						font-weight: 400;
						line-height: 14.4px;
						color: #000000;
					}
					> div {
						width: 100%;
						> div {
							.propertyCard {
								padding: 16px;
								.containerData {
									.containerImage {
										aspect-ratio: 16 / 9;
										overflow: hidden;
										border-radius: 8px;
										background-color: #f0eeff;
										img {
											width: 100%;
											height: 100%;
											object-fit: cover;
											object-position: center;
											display: block;
											border-radius: 8px;
										}
									}
									.containerInfo {
										margin-top: 8px;
										display: flex;
										justify-content: flex-start;
										align-items: flex-start;
										gap: 8px;
										flex-direction: column;
										p {
											&:first-child {
												font-size: 14px;
												font-weight: 700;
												line-height: 16.8px;
												color: #331860;
											}
											&:last-child {
												font-size: 12px;
												font-weight: 400;
												line-height: 14.4px;
												color: #625783;
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`
